// extracted by mini-css-extract-plugin
export default {"container":"FloatingMap_container__c8RDE","map":"FloatingMap_map__1z1kR"};